import React, {
  Dispatch, SetStateAction, useState,
} from 'react';
import {
  View, Text, TouchableOpacity, StyleSheet, ScrollView, TextInput, FlexStyle, Platform,
} from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import Colors from '../../../../../constants/Colors';
import { Area, Floor, Space } from '../../../../../components/Map/SetFloorsModal/FloorItem';
import isMobile from '../../../../../components/IsMobile';

interface FloorDropdownProps {
  selectedFloor: Floor,
  selectedLocationId: string,
  floorDropdownShown: boolean,
  setFloorDropdownShown: Dispatch<SetStateAction<boolean>>,
  setSelectedFloor: Dispatch<SetStateAction<Floor>>,
  setSelectedArea: Dispatch<SetStateAction<Area>>,
  setSelectedSpace: Dispatch<SetStateAction<Space>>,
  setSelectedLocationId?: Dispatch<SetStateAction<string>>,
  locations: object[],
  closeOtherDropdowns: () => void,
  disabled?: boolean,
  hideLabel?: boolean,
  listPositionAbsolute?: boolean,
  style?: FlexStyle | FlexStyle[],
}

const FloorDropdown = ({
  floorDropdownShown, setFloorDropdownShown, selectedFloor, setSelectedFloor, setSelectedLocationId,
  setSelectedArea, setSelectedSpace, selectedLocationId, locations, closeOtherDropdowns, disabled,
  hideLabel, listPositionAbsolute, style,
}: FloorDropdownProps) => {
  const [value, onChangeText] = useState<string>('');

  return <View
    style={[{ flex: 1 }, style]}
    testID='filter-assets-floor-list'
  >
    {hideLabel ? null : <Text style={styles.heading}>{'Floor'}</Text>}
    {floorDropdownShown ? <View style={styles.dropdownBox}>
      <TextInput
        placeholder='Search'
        style={[
          { marginLeft: 8, color: Colors.light.hereworksBlack600 },
          !isMobile && { outlineWidth: 0 },
        ]}
        placeholderTextColor={Colors.light.hereworksPrimaryGrey700}
        {...{ value, onChangeText }}
      />
      {!disabled && <TouchableOpacity
        style={{ flex: 1, alignItems: 'flex-end' }}
        onPress={() => {
          setFloorDropdownShown(false);
          closeOtherDropdowns();
        }}
      >
        <FontAwesome
          size={20}
          style={styles.icon}
          name={'angle-up'}
        />
      </TouchableOpacity>}
    </View> : <TouchableOpacity
      style={styles.dropdownBox}
      {...{ disabled }}
      onPress={() => {
        setFloorDropdownShown(!floorDropdownShown);
        closeOtherDropdowns();
      }}
    >
      <Text style={[
        styles.dropdownBoxText,
        // !selectedFloor && { color: Colors.light.hereworksPrimaryGrey800 },
      ]}>
        {selectedFloor?.Name ?? 'Select Floor'}
      </Text>
      {!disabled && <View style={{ alignItems: 'flex-end' }}>
        <FontAwesome
          size={20}
          style={styles.icon}
          name={floorDropdownShown ? 'angle-up' : 'angle-down'}
        />
      </View>}
    </TouchableOpacity>}
    {floorDropdownShown && <ScrollView
      nestedScrollEnabled
      indicatorStyle={'black'}
      style={[styles.dropdownView, listPositionAbsolute && styles.absoluteView]}
    >
      {[null, ...locations.sort((prev: Floor, next: Floor) => prev.Index - next.Index) ?? []]
        .map((floor: Floor) => {
          const selected: boolean = selectedLocationId === floor?.LocationId;
          return (!(value?.length > 0)
            || floor?.Name.toLowerCase().includes(value?.trim().toLowerCase())) && <TouchableOpacity
              key={`floor_option_${floor?.LocationId}`}
              onPress={() => {
                setSelectedFloor(floor);
                setSelectedLocationId?.(floor?.LocationId ?? '');
                if (!selected) {
                  setSelectedArea(null);
                  setSelectedSpace(null);
                }
                setFloorDropdownShown(false);
                closeOtherDropdowns();
              }}
              style={selected && styles.itemSelected}
            >
              <Text style={[styles.dropdownItemText, selected && styles.textSelected]}>
                {floor && `${floor.Number} - `}
                {floor?.Name ?? 'ALL FLOORS'}
              </Text>
            </TouchableOpacity>;
        })}
    </ScrollView>}
  </View>;
};

const styles = StyleSheet.create({
  dropdownBox: {
    width: '100%',
    borderWidth: 1.5,
    borderColor: Colors.light.hereworksBlue100,
    borderRadius: 10,
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    zIndex: 2,
    height: 40,
  },
  heading: {
    fontSize: 14,
    lineHeight: 18,
    marginTop: 12,
    marginBottom: 4,
    alignSelf: 'flex-start',
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack600,
  },
  dropdownView: {
    zIndex: 5,
    borderRadius: 10,
    borderWidth: 1.5,
    borderColor: Colors.light.hereworksPaleBlue900,
    backgroundColor: '#fff',
    marginTop: 4,
    maxHeight: 180,
    alignSelf: 'stretch',
  },
  dropdownBoxText: {
    fontFamily: 'Poppins_400Regular',
    fontSize: 14,
    color: Colors.light.hereworksBlack600,
    marginHorizontal: 12,
    flex: 1,
  },
  dropdownItemText: {
    marginLeft: 12,
    marginVertical: 9,
    fontFamily: 'Poppins_400Regular',
    fontSize: 14,
    color: Colors.light.hereworksPrimaryGrey,
  },
  textSelected: {
    color: '#FFF',
  },
  itemSelected: {
    backgroundColor: Colors.light.hereworksDarkBlue,
  },
  icon: {
    color: Colors.light.hereworksBlue500,
    marginRight: 12,
  },
  absoluteView: Platform.OS === 'android' ? {} : {
    position: 'absolute',
    top: 40,
    width: '100%',
  },
});

export default FloorDropdown;
